module.exports = __webpack_public_path__ + "static/media/fiscal_rank.dcdaf12c.csv";